/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { GetDbtimeResponse as TariffEditorApiContractGetDbtimeResponse } from '../models/TariffEditorApi/Contract/get-dbtime-response';

@Injectable({
  providedIn: 'root',
})
export class DatabaseTimeService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation apiTariffGetDbtimeGet
   */
  static readonly ApiTariffGetDbtimeGetPath = '/api/Tariff/GetDbtime';

  /**
   * receiving time.
   *
   * ### Claim
   *  boservice.tariff.getdbtime
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTariffGetDbtimeGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTariffGetDbtimeGet$Plain$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<TariffEditorApiContractGetDbtimeResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DatabaseTimeService.ApiTariffGetDbtimeGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TariffEditorApiContractGetDbtimeResponse>;
      })
    );
  }

  /**
   * receiving time.
   *
   * ### Claim
   *  boservice.tariff.getdbtime
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTariffGetDbtimeGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTariffGetDbtimeGet$Plain(params?: {
  },
  context?: HttpContext

): Observable<TariffEditorApiContractGetDbtimeResponse> {

    return this.apiTariffGetDbtimeGet$Plain$Response(params,context).pipe(
      map((r: StrictHttpResponse<TariffEditorApiContractGetDbtimeResponse>) => r.body as TariffEditorApiContractGetDbtimeResponse)
    );
  }

  /**
   * receiving time.
   *
   * ### Claim
   *  boservice.tariff.getdbtime
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiTariffGetDbtimeGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTariffGetDbtimeGet$Response(params?: {
  },
  context?: HttpContext

): Observable<StrictHttpResponse<TariffEditorApiContractGetDbtimeResponse>> {

    const rb = new RequestBuilder(this.rootUrl, DatabaseTimeService.ApiTariffGetDbtimeGetPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TariffEditorApiContractGetDbtimeResponse>;
      })
    );
  }

  /**
   * receiving time.
   *
   * ### Claim
   *  boservice.tariff.getdbtime
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiTariffGetDbtimeGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiTariffGetDbtimeGet(params?: {
  },
  context?: HttpContext

): Observable<TariffEditorApiContractGetDbtimeResponse> {

    return this.apiTariffGetDbtimeGet$Response(params,context).pipe(
      map((r: StrictHttpResponse<TariffEditorApiContractGetDbtimeResponse>) => r.body as TariffEditorApiContractGetDbtimeResponse)
    );
  }

}
